import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

function SelectStudentsDialog({ onClose, onOK, open, students, selectSingle=false }) {
  const [_selectedStudents, setSelectedStudents] = React.useState([]);

  const handleClose = () => {
    onClose();
  };

  const handleOK = () => {
    onOK(_selectedStudents);
  };

  const handleSelect = (value) => {
    setSelectedStudents(value);
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          width: 700,
          maxWidth: 700,
          height: 350
        },
      }}
      onClose={handleClose}
      open={open}
      aria-labelledby="select-students-dialog-title"
      aria-describedby="select-students-dialog-description"
    >
      <DialogTitle id="select-students-dialog-title">
        Select {selectSingle ? "Student" : "Student(s)"}
      </DialogTitle>

      <DialogContent>
        <InputLabel>Search and Select {selectSingle ? "Student" : "Student(s)"}</InputLabel>
        <Select
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          options={students}
          onChange={handleSelect}
          isMulti={!selectSingle}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="outlined">Cancel</Button>
        <Button variant="contained" onClick={handleOK}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SelectStudentsDialog;
